<template>
  <div class="fs-menu-divider"></div>
</template>

<script>
export default {
  name: 'fs-menu-divider',
};
</script>

<style scoped lang="scss">
@import '@styles/variables';

.fs-menu-divider {
  width: calc(100% + 1.6rem);
  margin: 0.7rem -0.8rem;
  border-top: 1px solid rgba($c-dark, 0.1);
}
</style>
